import React from 'react';
import PropTypes from 'prop-types';
import GelLaneDepositImage from './img/gel-side.svg';
import {Image} from '@learningblocks/storybook-components';

// import {
//   EVENTS,
//   RPM_UPDATE_RATE,
//   TIME_UPDATE_RATE,
//   FUNTION_CALL_INTERVAL,
//   PULSE_TIME,
//   formatView,
// } from './GelLaneDeposit.utils';
//
// import {
//   NOTIFY_EVENTS,
//   getNewTime
// } from '../Gelbox.utils';

import P2Plunger from './img/P2-Plunger.svg'
import P2NoTip from './img/P2.svg'
import P2Tip from './img/P2-Tip.svg'
import GenericPipetteFilled from './img/generic-pipette-filled.svg'
import GenericPipetteEmpty from './img/generic-pipette-empty.svg'
import P2TipSolution from './img/P2-Tip-Solution-Blue.svg'

import P20Plunger from './img/P20-Plunger.svg'
import P20NoTip from './img/P20.svg'
import P20Tip from './img/P20-Tip.svg'
import P20TipSolution from './img/P20-Tip-Solution-Blue.svg'

import P200Plunger from './img/P200-Plunger.svg'
import P200NoTip from './img/P200.svg'
import P200Tip from './img/P200-Tip.svg'
import P200TipSolution from './img/P200-Tip-Solution-Blue.svg'

import P1000Plunger from './img/P1000-Plunger.svg'
import P1000NoTip from './img/P1000.svg'
import P1000Tip from './img/P1000-Tip.svg'
import P1000TipSolution from './img/P1000-Tip-Solution-Blue.svg'

const images = {
  P2Plunger: P2Plunger,
  P2NoTip: P2NoTip,
  P2Tip: P2Tip,
  P2TipSolution: P2TipSolution,
  P20Plunger: P20Plunger,
  P20NoTip: P20NoTip,
  P20Tip: P20Tip,
  P20TipSolution: P20TipSolution,
  P200Plunger: P200Plunger,
  P200NoTip: P200NoTip,
  P200Tip: P200Tip,
  P200TipSolution: P200TipSolution,
  P1000Plunger: P1000Plunger,
  P1000NoTip: P1000NoTip,
  P1000Tip: P1000Tip,
  P1000TipSolution: P1000TipSolution,
  GenericPipetteEmpty,
  GenericPipetteFilled
}

export function GelLaneDeposit(props) {

  return (
    <div className={props.className}>
      <div className={`${props.className}_image`}>
        {(props.pipetteId !== null)?(
          <img
            className={props.type+"-pipette pipette"}
            style={{
              pointerEvents: "none",
              transform: "scale(1) rotate(1deg)",
              left: "160px", //props.interactionProps.pipettes[props.pipetteId - 1].solution !== null? "166px": 
              top: "-113px",
              position: "relative",
              zIndex: 99
            }}
            src={
              (props.interactionProps.pipettes[props.pipetteId - 1].tipAttached)?
                (props.interactionProps.pipettes[props.pipetteId - 1].solution !== null)?
                  images['GenericPipetteFilled']
                : images['GenericPipetteEmpty']
              : images[props.interactionProps.pipettes[props.pipetteId - 1].type+"NoTip"]
            }
            alt={props.interactionProps.pipettes[props.pipetteId - 1].type+' micropipette'}
          />
        ):null}
        {(!props.lanes[props.selectedLane].empty)?(
          <div
            //ref={ref}
            style={{
            position: "absolute",
            width: "68px",
            height: "39px",
            left: "143px",
            top: "268px",
            zIndex: "99",
            background: "#00AEEF"
          }}></div>
        ):null}
        <Image
          src={GelLaneDepositImage}
          alt='Controls Panel'
          className={`${props.className}_image_main`}
        />
      </div>
    </div>
  );
}

GelLaneDeposit.propTypes = {
  /**
   * ClassName to set on component
   */
  className: PropTypes.string,
  /**
   * Current rpm value set
   */
  rpmValue: PropTypes.number,
  /**
   * Current Runtime set
   */
  timeValue: PropTypes.instanceOf(Date),
  /**
   * Time left for centrifuge to run to completion
   */
  timeLeft: PropTypes.instanceOf(Date),
  /**
   * Function to set RPM value
   */
  setRPM: PropTypes.func,
  /**
   * Function to set Run Time
   */
  setTimeValue: PropTypes.func,
  /**
   * Function to invoke when to  run the Centrifuge
   */
  runCentrifuge: PropTypes.func,
};

GelLaneDeposit.defaultProps = {};
